import styled, { css, keyframes } from "styled-components";

const growFromNothing = keyframes`
    from {
        transform: scale(0);
    }
    to {
        transform: scale(1);
    }
`

const growFromNothingWithBounce = keyframes`
    0% {
        transform: scale(0);
    }
    60% {
        transform: translate(0, 0.8rem);
    }
    80% {
        transform: translate(0, -0.2rem);
    }
    100% {
        transform: scale(1);
        transform: translate(0, 0rem);
    }
`

const Container = styled.div`

    ${({size}) => css`
        position: relative;
        height: ${size*.8}rem;
        width: ${size}rem;

        & img {
            width: ${size}rem;
        }
        & #big, & #little {
            position: absolute;
            top: 0;
            left: 0;
        }

        #big {
            animation: ${growFromNothing} 0.6s 1;
            animation-timing-function: ease-in;
        }

        #little {
            animation: ${growFromNothingWithBounce} 0.5s 1;
            animation-timing-function: ease-in;
            animation-delay: 0.3s;
            z-index: 10;
        }
    `}
`


const Animation = ({size=10}) => {

    return (
        <Container {...{size}}>
            <img id='big' src={require('assets/img/big-heart.png')} alt='big-heart' />
            <img id='little' src={require('assets/img/little-heart.png')} alt='little-heart' />
        </Container>
    )
}

export default Animation;